export const ACTIONONE_SUCCESS = 'ACTIONONE_SUCCESS';

export const USER_NAME = 'USER_NAME';
export const USER_SURNAME = 'USER_SURNAME';
export const USER_POSITION = 'USER_POSITION';
export const USER_EMAIL = 'USER_EMAIL';
export const USER_PHONE = 'USER_PHONE';
export const USER_IMAGE = 'USER_IMAGE';

export const SPINNER = 'SPINNER';
export const IMAGE_UPLOAD_ERROR = 'IMAGE_UPLOAD_ERROR';
export const DATA_FETCH = 'DATA_FETCH';
